import React, { FC } from 'react'
import { Box } from '@mui/material'

type ContractAlertDotProps = {
  size: number
  hidden: boolean
  top?: number
}

export const ContractAlertDot: FC<ContractAlertDotProps> = ({ size, hidden, top }) => {
  return (
    <Box
      component={'span'}
      sx={{
        position: 'absolute',
        top,
        right: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#EF2828',
      }}
      hidden={hidden}
    />
  )
}
